<template>
  <div class="header" :style="bannerStyle">
    <div class='top'>
      <div class='top-con'>
        <div class='logo'></div>
        <div class="menuContent">
          <Menu @menu-selected="handleMenuSelect"></Menu>
        </div>
      </div>
    </div>
    <div class='banner'>
      <ul>
        <!-- <li>品牌</li> -->
        <li>{{ bannerText1 }}</li>
        <li><span>{{ bannerText2 }}</span></li>
        <li class="line"></li>
      </ul>
    </div>
    <component v-if="selectedSubMenu" :is="selectedSubMenu"></component>
<!--    <SubMenu></SubMenu>-->
  </div>
</template>

<script>
import Menu from '../components/Menu.vue'
import SubMenu1 from '../components/SubMenu1.vue'
import SubMenu2 from '../components/SubMenu2.vue'

export default {
  name: 'Header',
  components: {
    Menu,
    SubMenu1,
    SubMenu2,
  },
  props: {
    bannerBg: {
      type: String,
      default: 'url(../assets/banner1@2x.png)' // 默认背景图片 URL
    },
    bannerText1: {
      type: String,
      default: '' // 默认文本
    },
    bannerText2: {
      type: String,
      default: '' // 默认文本
    }
  },
  data() {
    return {
      // bannerStyle: {}, // 你的样式对象
      selectedSubMenu: '', // 默认不加载任何子菜单
      menuMap: { // 主菜单项到子菜单组件名称的映射
        'menu0': '',
        'menu1': 'SubMenu1',
        'menu2': 'SubMenu2',
      },
    }
  },
  methods: {
    handleMenuSelect(menuItem) {
      this.selectedSubMenu = this.menuMap[menuItem] || ''; // 如果没有，则设置为空字符串
      console.log(this.selectedSubMenu);
    }
  },
  // 监听Menu组件发出的menu-selected事件
  mounted() {

    this.$refs.menu.$on('menu-selected', this.handleMenuSelect);
  },
  beforeDestroy() {
    // 在组件销毁前移除事件监听器
    this.$refs.menu.$off('menu-selected', this.handleMenuSelect);
  },
  computed: {
    bannerStyle() {
      return {
        backgroundImage: `url(${this.bannerBg})`,
        // 可以添加其他样式，如背景大小、位置等
      };
    }
  }
}
</script>

<style>
a {
  text-decoration: none;
  color: #fff;
}

/* 在这里添加针对手机屏幕的样式 */
.header {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-image: url(../assets/banner2@2x.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  color: #fff;
}

.top {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
}

.top-con {
  padding-left: 5.625vw;
  padding-right: 5.625vw;
  display: flex;
  justify-content: space-between;
}

.logo {
  height: 6vw;
  margin-top: 1vw;
  margin-bottom: 1vw;
  flex-basis: 26.25vw;
  background-image: url(../assets/logo@2x.png);
  background-repeat: no-repeat;
  background-size: contain;
}

Menu {
  display: none;
  visibility: hidden;
}

.banner {
  text-align: left;
  padding-top: 10vw;
  padding-bottom: 15vw;
}

.banner ul {
  padding-left: 5.625vw
}

.banner ul li {
  font-size: 6vw;
  text-shadow: 0.1875vw 0.1875vw rgba(0, 0, 0, .5);
}

.banner ul li span {
  font-size: 4vw;
}


.line {
  width: 6vw;
  border-top: #fff 0.375vw solid;
  box-shadow: 0.1875vw 0.1875vw rgba(0, 0, 0, .5);
}

component {
  display: none;
}


/*
视口宽度<768px 宽度100%，内边距30px
  视口宽度 >= 768px，宽度768px，
  视口宽度 >= 960px 宽度900px,
  视口宽度 >= 1200px 宽度1200px
*/

@media (min-width: 768px) {

  .header {
    /*height: 75vw;*/
    justify-content: space-between;
  }

  .logo {
    height: 35px;
    flex-basis: 120px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .top-con {
    width: 740px;
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  .menuContent {
    margin-top: 6px;
  }

  .banner {
    width: 700px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .banner ul {
    padding-left: 0;
  }

  .banner ul li {
    font-size: 40px;
    text-shadow: 1px 1px rgba(0, 0, 0, .5);
  }

  .banner ul li span {
    font-size: 26px;
  }

  .line {
    width: 50px;
    border-top: #fff 2px solid;
    box-shadow: 1px 1px rgba(0, 0, 0, .5);
  }

  component {
    display: block;
    visibility: hidden;
  }



}

@media (min-width: 960px) {
  .top-con {
    width: 900px;
    margin-left: auto;
    margin-right: auto;
  }

  .banner {
    width: 900px;
  }
}

@media (min-width: 1200px) {
  .header {
    background-size:cover;
    background-position: center center;
  }

  .top-con {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .logo {
    /*height: 13.125vw;*/
    /*flex-basis: 30vw;*/
  }

  .banner {
   width: 1200px;
    padding-top: 150px;
    padding-bottom:150px;
  }


  .banner ul {

  }

  .banner ul li span {
    /*font-size: 6.75vw;*/
  }

  .line {
    /*width: 13.5vw;*/
    /*border-top: #fff 0.375vw solid;*/
    /*box-shadow: 0.1875vw 0.1875vw rgba(0, 0, 0, .5);*/
  }

  component {
  }

  .banner ul {
    /*padding-left: 200px;*/
  }
}
</style>